const messages = {
    "title": "Onderhoud",
    "description": "Er worden momenteel noodzakelijke onderhoudswerkzaamheden uitgevoerd op de servers.<br/><br/>Daarom heeft u momenteel geen toegang tot <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b>.<br/><br/>Wij vragen om uw geduld en danken u voor uw begrip.<br/><br/>Uw Bridgestone-team"
}
export default {
    messages
}
